import { render, staticRenderFns } from "./CustomSelection.vue?vue&type=template&id=22b61f1a&"
import script from "./CustomSelection.vue?vue&type=script&lang=js&"
export * from "./CustomSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports